import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';
import Select from 'react-select';
import { DataContext } from '../../stores/course-table-store';
import { HandleCourseStatusOptions,HandleExlFilter, InputDebouncer } from '../tables/shared/FilterEventHelpers';
import DatePicker, { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import { DataContext as CovDataStore } from '../../store';
import { courseCategoryOptions, courseLanguageOptions, courseStatusOptions, getOptionsObjectValuesWithLabel, courseRoleOptions, courseFormatOptions, translateOptionLabel } from './shared/translations';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { COURSE_STATUS_CANCELLED, COURSE_STATUS_FINISHED, COURSE_STATUS_INPROGRESS, COURSE_STATUS_NONE, COURSE_STATUS_SCHEDULED, DATE_PLACEHOLDER, NO, SHOW_ALL, YES } from '../../i18n/keyConstants';
registerLocale('sv', sv);

const FilterCell = ({ column, children, ...restProps }) => {
    const { store: covStore } = useContext(CovDataStore);
    const user = covStore?.user;
    const [date, setDate] = useState();
    const columnName = column.name;
    const { t } = useTranslation(['shared']);
    const {
        store: {
            selectedFilters,
            filters,
            isResettingFilters,
            selectedCourseStatus,
            selectedCourseCategory,
            selectedCourseLanguage,
            selectedIsRegisteredOption,
            selectedCourseFormat
        },
        dispatch
    } = useContext(DataContext);
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);
    const intervalRef = useRef(null);

    const IsTextInputColumn = () => {
        return (columnName !== 'status' || columnName !== 'isRegistered');
    }

    const handleOptionValueChange = (selected) => {
        if (column.name === 'status') {
            { dispatch({ type: 'SELECTED_COURSE_STATUS', payload: selected }) }
        }
        else if (column.name === 'category') {
            { dispatch({ type: 'SELECTED_COURSE_CATEGORY', payload: selected }) }
        }
        else if (column.name === 'language') {
            { dispatch({ type: 'SELECTED_COURSE_LANGUAGE', payload: selected }) }
        }
        else if (column.name === 'isRegistered') {
            { dispatch({ type: 'SELECTED_ISREGISTERED_OPTION', payload: selected }) }
        }
        else if (column.name === 'startDate') {
            selected.value = moment(selected.value);
            { dispatch({ type: 'SELECTED_COURSE_STARTDATE', payload: selected }) }
        }
        else if (column.name === 'endDate') {
            selected.value = moment(selected.value);
            { dispatch({ type: 'SELECTED_COURSE_ENDDATE', payload: selected }) }
        }
        else if(column.name === 'format') {
            selected.value = moment(selected.value);
            { dispatch({type: 'SELECTED_COURSE_FORMAT', payload: selected})}
        }
    }

    const updateDate = (newDate) => {
        setDate(newDate);
        HandleExlFilter({ label: '', value: newDate }, filters, handleOptionValueChange, columnName, columnName === 'startDate' ? 'greaterThanOrEqual' : 'lessThanOrEqual', '', dispatch);
    };

    useEffect(() => {
        if (IsTextInputColumn()) {
            if (!(chosenValue === selectedFilters[columnName])) {
                return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenValue]);

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            setDate('');
            dispatch({ type: 'SELECTED_FILTERS_AND_FILTERS_RESET', columnName, payload: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);


    if (columnName === 'category' || columnName === 'language' || columnName === 'format') {
        const selectedValue = columnName === 'category' ? selectedCourseCategory
            : columnName === 'language' ? selectedCourseLanguage 
            : selectedCourseFormat;
        const options = columnName === 'category' ? courseCategoryOptions 
            : columnName === 'language' ? courseLanguageOptions
            : courseFormatOptions;

        if (selectedValue[0]?.label === 'showAll') {
            selectedValue[0].label = t(SHOW_ALL, {ns: 'shared'})
        }

        return (
            <th>
                <Select className={`${columnName}-select`}
                    isClearable={false}
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={selectedValue}
                    options={[...getOptionsObjectValuesWithLabel(options,t), {label: t(SHOW_ALL), value: ''}]}
                    onChange={(e) => {
                        HandleExlFilter(e, filters, handleOptionValueChange, columnName, 'equal', '', dispatch);
                    }}
                />
            </th>
        );
    }
    if (columnName === 'isRegistered') {
        if (selectedIsRegisteredOption[0]?.label === 'showAll') {
            selectedIsRegisteredOption[0].label = t(SHOW_ALL, { ns: 'shared' })
        }
        return (
            <th>
                <Select className="status-select"
                    isClearable={false}
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={selectedIsRegisteredOption}
                    options={[
                        { label: t(YES), value: 'true' },
                        { label: t(NO), value: 'false' },
                        { label: t(SHOW_ALL), value: '' },
                    ]}
                    onChange={(e) => {
                        HandleExlFilter(e, filters, handleOptionValueChange, columnName, e.value === 'true' ? 'equal' : e.value === 'false' ? 'notEqual' : '', user.id, dispatch);
                    }}
                />
            </th>
        );
    }
    if (columnName === 'startDate') {
        return (
            <th>
                <DatePicker className="form-control"
                    placeholderText={t(DATE_PLACEHOLDER)}
                    dateFormat='yyyy-MM-dd'
                    selected={date}
                    onChange={(newDate) => updateDate(newDate)}
                    locale={localStorage.getItem('userLocale')}
                />
            </th>
        );
    }
    if (columnName === 'endDate') {
        return (
            <th>
                <DatePicker className="form-control"
                    placeholderText={t(DATE_PLACEHOLDER)}
                    dateFormat='yyyy-MM-dd'
                    selected={date}
                    onChange={(newDate) => updateDate(newDate)}
                    locale={localStorage.getItem('userLocale')}
                />
            </th>
        );
    }
    if (columnName === 'status') {
        return (
            <th>
                <Select
                    isClearable={false}
                    isMulti
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={translateOptionLabel(selectedCourseStatus, t)}
                    options={[
                        { label: t(COURSE_STATUS_NONE), value: 0 },
                        { label: t(COURSE_STATUS_SCHEDULED), value: 1 },
                        { label: t(COURSE_STATUS_INPROGRESS), value: 2 },
                        { label: t(COURSE_STATUS_FINISHED), value: 3 },
                        { label: t(COURSE_STATUS_CANCELLED), value: 4 },
                        { label: t(SHOW_ALL, {ns: 'shared'}), value: 'showAll' },
                    ]}
                    onChange={(e) => {
                        HandleCourseStatusOptions(e, filters, selectedCourseStatus, handleOptionValueChange, dispatch);
                    }}
                />
            </th>
        )
    }

    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        }
    });

    return (
        <TableFilterRow.Cell
            column={column}
            {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
}

export default FilterCell;
